export const STANDARD_TRIP_TYPES = [
  'Domestic',
  'International',
  'Adventure',
  'Honeymoon',
  'Luxury',
  'Family'
];

export const ALL_TRIP_TYPE_OPTIONS = [
  'Domestic',
  'International',
  'Adventure',
  'Honeymoon',
  'Luxury',
  'Family',
  'Custom'
];

export const parseDurationString = (dur) => {
  if (!dur) return { days: '', nights: '' };
  const dMatch = dur.match(/(\d+)\s*Days?/i);
  const nMatch = dur.match(/(\d+)\s*Nights?/i);
  let d = dMatch ? dMatch[1] : '';
  let n = nMatch ? nMatch[1] : '';
  if (!d && !n && !isNaN(parseInt(dur))) {
    d = parseInt(dur).toString();
  }
  return { days: d, nights: n };
};

export const formatRoleName = (role) => {
  if (!role) return '';
  if (role === 'subadmin') return 'SUB-ADMIN';
  return role.toUpperCase();
};

export const createDefaultFormData = () => ({
  itinerary_title: '',
  location: '',
  trrip_type: 'Domestic',
  custom_trrip_type: '',
  duration: '',
  description: '',
  cover_image_url: '',
  attachment_url: '',
  attachment_type: 'pdf',
  status: 'published',
  days: [
    {
      day: 'Day 1',
      date: '',
      pointers: ['', '', '']
    }
  ]
});
